let items = document.querySelectorAll(".mega-menu")
let header = document.querySelector('header')
let backgrounde = document.querySelector('#MainContent');
let headerinlinemenu = document.querySelector('header__inline-menu')
let divmegamenuaperto = document.querySelector("mega-menu__content")
let currentItemIndex

items.forEach((item, itemIndex) => {
  const content = item.querySelector(".mega-menu__content")
  item.addEventListener("mouseover", () => {
    if (
      (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
      (currentItemIndex && currentItemIndex !== itemIndex)
    ) {
      items[currentItemIndex].removeAttribute("open")
    }

    currentItemIndex = itemIndex
    item.setAttribute("open", true)
  })

  backgrounde.addEventListener("mouseover", (event) => {
    let close = true

    const closeTimeout = setTimeout(() => {
      if (close) item.removeAttribute("open")
    }, 300)
    
    content.addEventListener("mouseover", () => {
      close = false
      //backgrounde.style.filter = 'blur(12px)';
    })

    item.addEventListener("mouseover", () => {
      clearTimeout(closeTimeout)
    })
  })

  content.addEventListener("mouseleave", () => {
    item.removeAttribute("open")
    //backgrounde.style.filter = 'none';
  })
})


